module.exports = __webpack_public_path__ + "static/media/5.2c7f542e.jpg";